module.exports = __webpack_public_path__ + "static/Libraro-6c293ab11dad3b15a5a86ef135083233.png";